<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>

          <!-- Dialog export / import -->
          <v-col cols="12">
            <v-btn color="primary" depressed @click="dialogAdd = true, validate('ADD')">
              <v-icon left>mdi-text-box-plus</v-icon>
              Add
            </v-btn>
            <!-- <v-btn color="yellow-light">
              <v-icon left>mdi-download</v-icon>
              <download-excel
                class="btn btn-default"
                :data="export_data"
                :fields="export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
              >
                Export Data
              </download-excel>
            </v-btn>
            <v-btn color="yellow-light" depressed @click="dialogImport = true">
              <v-icon left>mdi-import</v-icon>
              Manage Data By Excel.xls
            </v-btn> -->
          </v-col>
          <!-- Import -->
          <!-- <v-dialog v-model="dialogImport" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">จัดการไฟล์ผ่าน excel.xls</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <input type="file" @change="importData" accept=".xls" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table
                          :headers="columnsImport"
                          :items="dataItemImport"
                          :items-per-page="5"
                          class="elevation-1"
                        ></v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  color="red darken-1"
                  text
                  @click="(dialogImport = false), (dataItemImport = [])"
                >
                  ปิด
                </v-btn>
                <template v-if="!dataItemImportChecKHide">
                  <v-btn
                    elevation="2"
                    color="red"
                    text
                    @click="importDataApprove('delete')"
                  >
                    ล้างข้อมูลทั้งหมดที่เลือก
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="blue darken-1"
                    text
                    @click="importDataApprove('update')"
                  >
                    ปรับปรุงข้อมูลที่ตรงกัน
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="green darken-1"
                    text
                    @click="importDataApprove('add')"
                  >
                    นำเข้าใหม่ทั้งหมด
                  </v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
          <!-- end Import -->

          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                   <v-form
                      ref="form_add"
                      v-model="valid_add"
                      lazy-validation
                    >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Username*"
                        v-model="formAdd.userName"
                         :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Password*"
                        v-model="formAdd.userPassword"
                        :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        required
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12">
                      <v-text-field
                        v-model="formAdd.userEmail"
                        :rules="[rules.required, rules.email]"
                        label="E-mail"
                      ></v-text-field>
                    </v-col> -->
                    <v-col class="d-flex" cols="12">
                      <v-autocomplete
                        clearable
                        v-model="formAdd.userType"
                        :items="userTypeItem"
                        label="ประเภท Account"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        clearable
                        v-model="formAdd.userTypeGroup"
                        :items="UserTypeGroup"
                        attach
                        chips
                        label="กลุ่มผู้ใช้งานเริ่มต้น"
                        :required="required"
                       :rules="[v => !this.required || !!v || 'Field is required']"
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <!-- <v-col cols="12">
                      <v-autocomplete
                        clearable
                        multiple
                        v-model="formAdd.userSubTypeGroup"
                        :items="UserTypeGroup"
                        attach
                        chips
                        label="กลุ่มผู้ใช้งานเลือก"
                        dense
                      ></v-autocomplete>
                    </v-col> -->
                    <v-col cols="12">
                      <v-autocomplete
                        chips
                        clearable
                        v-model="formAdd.empCode"
                        :items="EmployeeName"
                        label="พนักงาน*"
                         attach
                        :required="required"
                       :rules="[v => !this.required || !!v || 'Field is required']"
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-menu
                        ref="ExpireMenu"
                        v-model="ExpireMenu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formAdd.EXPIRY_DATE"
                            label="วันที่หมดอายุ"
                            prepend-icon="mdi-calendar"
                             :rules="nameRules"
                             required
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="formAdd.EXPIRY_DATE" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="ExpireMenu = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.ExpireMenu.save(formAdd.EXPIRY_DATE)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                  </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="(dialogAdd = false), clearData()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  :disabled="!valid_add"
                  @click="addData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form
                      ref="form_update"
                      v-model="valid_update"
                      lazy-validation
                    >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="userCode*"
                        v-model="formUpdate.userCode"
                        :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="userName*"
                        v-model="formUpdate.userName"
                        :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="userPassword*"
                        v-model="formUpdate.userPassword"
                        :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        required
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.userEmail"
                        :rules="[rules.required, rules.email]"
                        label="E-mail"
                      ></v-text-field>
                    </v-col> -->
                    <v-col class="d-flex" cols="12">
                      <v-autocomplete
                        clearable
                        v-model="formUpdate.userType"
                        :items="userTypeItem"
                        label="ประเภท Account"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        clearable
                        v-model="formUpdate.userTypeGroup"
                        :items="UserTypeGroup"
                        attach
                        chips
                        label="กลุ่มผู้ใช้งานเริ่มต้น"
                        :required="required"
                       :rules="[v => !this.required || !!v || 'Field is required']"
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        clearable
                        multiple
                        v-model="formUpdate.userSubTypeGroup"
                        :items="UserTypeGroup"
                        attach
                        chips
                        label="กลุ่มผู้ใช้งานเลือก"
                      ></v-autocomplete>
                    </v-col>
                    <!-- <v-col cols="12">
                      <v-autocomplete
                      chips
                        clearable
                        v-model="formUpdate.empCode"
                        :items="EmployeeNameEdit"
                        label="พนักงาน*"
                         attach
                        :required="required"
                       :rules="[v => !this.required || !!v || 'Field is required']"
                        dense
                      ></v-autocomplete>
                    </v-col> -->
                    <v-menu
                              ref="ExpireMenu"
                              v-model="ExpireMenuUpdate"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                               <v-combobox
                                v-model="formUpdate.EXPIRY_DATE"
                                label="วันที่หมดอายุ"
                            prepend-icon="mdi-calendar"
                             :rules="nameRules"
                             required
                            readonly
                            v-bind="attrs"
                            v-on="on"
                              ></v-combobox>
                              </template>
                              <v-date-picker v-model="formUpdate.EXPIRY_DATE" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="ExpireMenuUpdate = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.ExpireMenuUpdate.save(formUpdate.EXPIRY_DATE)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                  </v-row>
                    </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="blue darken-1"
                  text
                  @click="dialogEdit = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  :disabled="!valid_update"
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                   <v-form
                      ref="form_update"
                      v-model="valid_update"
                      lazy-validation
                    >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="userCode*"
                        v-model="formUpdate.userCode"
                        :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        outlined
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="userName*"
                        v-model="formUpdate.userName"
                        :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        outlined
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  text
                  :disabled="!valid_update"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                   <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date(item.CREATE_DATE) }}
                  </template>
                   <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogEdit = true), getDataById(item), validate('UPDATE')"
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                    <v-btn
                      color="red"
                      dark
                      fab
                      small
                      @click.stop="(dialogDelete = true), getDataById(item)"
                    >
                      <v-icon> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      PK: '',
      path: '/system_user/', // Path Model
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      ExpireMenu: false,
      ExpireMenuUpdate: false,
      code: 'U', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        userCode: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        userType: 'USER',
        userTypeGroup: '',
        userSubTypeGroup: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formAdd: {
        userCode: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        userType: 'USER',
        userTypeGroup: 'Employee Operation',
        userSubTypeGroup: '',
        empCode: '',
        EXPIRY_DATE: ''
      },
      formUpdate: {
        userCode: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        userType: 'USER',
        userTypeGroup: 'Employee Operation',
        userSubTypeGroup: '',
        empCode: '',
        EXPIRY_DATE: ''
      },
      formUpdateItem: {
        userCode: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        userType: '',
        userTypeGroup: '',
        userSubTypeGroup: '',
        empCode: '',
        EXPIRY_DATE: ''
      },
      nameRules: [
        (v) => !!v || 'Field is required',
        (v) => v.length <= 30 || 'Field must be less than 30 characters'
      ],
      inputRule: [v => v.email.length >= 3 || 'Please select a user'],
      rules: {
        required: (value) => !!value || 'Required.',
        counter: (value) => value.length <= 20 || 'Max 20 characters',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการ Account',
          disabled: true,
          href: '/System/Users'
        }
      ],
      // End Menu Config
      // Data Table Config
      columns: [
        { text: 'ID', value: 'userId' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'Username', value: 'userName' },
        { text: 'กลุ่มผู้ใช้งาน', value: 'userTypeGroup' },
        { text: 'ประเภท Account', value: 'userType' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'วันหมดอายุ คงเหลือ (วัน)', value: 'ExpireDateDiff' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'userId', value: 'userId' },
        { text: 'userCode', value: 'userCode' },
        { text: 'userName', value: 'userName' },
        { text: 'userPassword', value: 'userPassword' },
        { text: 'userType', value: 'userType' },
        { text: 'userTypeGroup', value: 'userTypeGroup' },
        { text: 'userSubTypeGroup', value: 'userSubTypeGroup' },
        { text: 'empCode', value: 'empCode' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'System-User-Account.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        userId: 'userId',
        userCode: 'userCode',
        userName: 'userName',
        userPassword: 'userPassword',
        userEmail: 'userEmail',
        userType: 'userType',
        userTypeGroup: 'userTypeGroup',
        userSubTypeGroup: 'userSubTypeGroup',
        empCode: 'empCode'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      UserTypeGroup: [],
      userTypeItem: ['USER', 'HR'],
      EmployeeName: [],
      EmployeeNameEdit: [],
      valid_add: true,
      valid_update: true,
      required: {
        type: Boolean,
        default: false
      }
    }
  },
  async mounted () {
    this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(this.DNS_IP, this.path)
    await this.reloadData()
  },
  methods: {
    async reloadData (item) {
      await this.employeeName()
      await this.employeeNameEdit()
      await this.getDataTypeGroup()
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getDataById (item) {
      // Load user type group
      this.PK = item.userId
      await this.reloadData()
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "getID?userId=" + item.userId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('get id : ', response)
          this.dataReady = true
          if (response.data) {
            if (response.data.userSubTypeGroup) {
              response.data.userSubTypeGroup = JSON.parse(response.data.userSubTypeGroup)
            }
            Object.assign(this.formUpdate, response.data)
            this.formUpdate.EXPIRY_DATE = this.momenDate_1(response.data.EXPIRY_DATE)
            delete this.formUpdate['userId']
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['RECORD_STATUS']
            console.log('getDataById', this.formUpdate)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          // console.log('error function getDataById : ', error)
        })
    },
    async employeeName () {
      // Clear Data ทุกครั้ง
      this.EmployeeName = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/getISNotConnectUser",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.empCode
            s.text = d.empFull_NameTH
            d = s
            this.EmployeeName.push(d)
          }
          // // console.log('employeeName : ', this.EmployeeName)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log(error)
        })
    },
    async employeeNameEdit () {
      // Clear Data ทุกครั้ง
      this.EmployeeNameEdit = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.empCode
            s.text = d.empFull_NameTH
            d = s
            this.EmployeeNameEdit.push(d)
          }
          // // console.log('employeeName : ', this.EmployeeName)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log(error)
        })
    },
    async checkform () {
    },
    async addData () {
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.userCode = this.code + this.generateCodeGlobal()
      // YYYY-MM-DD
      this.formAdd.EXPIRY_DATE = this.momenDate_1(this.formAdd.EXPIRY_DATE)
      //
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //

      if (this.formAdd.userSubTypeGroup) {
        this.formAdd.userSubTypeGroup = JSON.stringify(this.formAdd.userSubTypeGroup)
      }

      console.log('form', JSON.stringify(this.formAdd))

      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              // console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.getDataGlobal(this.DNS_IP, this.path)
              await this.reloadData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              // console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // Config User ทำรายการล่าสุด
      this.formUpdateItem.LAST_USER = this.$session.getAll().data.userName
      // End Config User ทำรายการล่าสุด

      // YYYY-MM-DD
      this.formUpdateItem.EXPIRY_DATE = this.momenDate_1(this.formUpdate.EXPIRY_DATE)

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }
      // console.log('this.formUpdateItem', this.formUpdateItem)

      if (this.formUpdateItem.userSubTypeGroup) {
        this.formUpdateItem.userSubTypeGroup = JSON.stringify(this.formUpdateItem.userSubTypeGroup)
      }

      // Debug
      // console.log('EDIT PK : ', this.PK)
      // console.log('formUpdateItem', JSON.stringify(this.formUpdateItem))
      // End Debug
      // สำหรับ แก้ไขข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนแก้ไขล่าสุด
      //
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + this.PK,
              this.formUpdateItem,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              // console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              await this.getDataGlobal(this.DNS_IP, this.path)
              await this.reloadData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              // console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      // console.log('DELETE PK : ', this.PK)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      // this.deleteDataSubmit(this.DNS_IP, this.path, this.PK)
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "delete/" + this.PK,
              this.formUpdate,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              // console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.getDataGlobal(this.DNS_IP, this.path)
              await this.reloadData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              // console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async getDataTypeGroup () {
      // Clear Data ทุกครั้ง
      this.UserTypeGroup = []
      // // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user_type_group/" + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.userTypeGroupName
            s.text = d.userTypeGroupName
            d = s
            // console.log(d)
            this.UserTypeGroup.push(d)
          }
          // // console.log('getDataTypeGroup : ', this.UserTypeGroup)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log(error)
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        // console.log('Key', key)
        // console.log('Value', this.formAdd)
        if (key === 'userType') {
          if (this.formAdd[key]) {
            this.formAdd[key] = 'USER'
          }
        } else {
          if (this.formAdd[key]) {
            this.formAdd[key] = ''
          }
        }
      }

      // eslint-disable-next-line no-redeclare
      for (var key in this.search) {
        // console.log('Key', key)
        // console.log('Value', this.search)
        if (this.search[key]) {
          this.search[key] = ''
        }
      }
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/System/Users.vue